import { css } from '@emotion/react';

import { campaignManagerTheme, drawerWidth } from '@campaign-manager/theme';

// CSS Grid-based wizard layout
// This replaces the fragile flex-based layout with explicit grid areas
// NO position: fixed, absolute, or sticky - all positioning via CSS Grid
export const WIZARD_HEADER_HEIGHT = 64;
export const WIZARD_SIDEBAR_WIDTH = drawerWidth;
export const WIZARD_CONTEXT_DRAWER_WIDTH = 360;

// Basic 2-column layout (sidebar + main)
// Fixed to viewport - areas scroll internally
// Actions are in the header (Linear/Stripe pattern)
export const wizardLayoutRoot = css`
  display: grid;
  height: 100vh;
  grid-template-columns: ${WIZARD_SIDEBAR_WIDTH}px 1fr;
  grid-template-rows: ${WIZARD_HEADER_HEIGHT}px 1fr;
  grid-template-areas:
    'header  header'
    'sidebar main';
`;

// 3-column layout with context drawer (sidebar + main + context)
// Fixed to viewport - areas scroll internally
export const wizardLayoutRootWithContext = css`
  display: grid;
  height: 100vh;
  grid-template-columns: ${WIZARD_SIDEBAR_WIDTH}px 1fr ${WIZARD_CONTEXT_DRAWER_WIDTH}px;
  grid-template-rows: ${WIZARD_HEADER_HEIGHT}px 1fr;
  grid-template-areas:
    'header  header  header'
    'sidebar main    context';
`;

export const headerArea = css`
  grid-area: header;
  z-index: 1100;
`;

export const sidebarArea = css`
  grid-area: sidebar;
  background-color: ${campaignManagerTheme.color.groundZeroSurface};
  overflow-y: auto;
`;

export const mainArea = css`
  grid-area: main;
  background-color: ${campaignManagerTheme.color.groundZeroSurface};
  display: flex;
  flex-direction: column;
  padding: 24px 20px 24px 1px;
  overflow-y: auto;
`;

// Wizard header with logo and actions (Linear pattern)
export const wizardHeaderContent = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 24px;
  background-color: #fff;
  border-bottom: 1px solid #e3e3e3;
`;

export const wizardHeaderLogo = css`
  display: flex;
  align-items: center;
`;

export const wizardHeaderActions = css`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const contextArea = css`
  grid-area: context;
  background-color: ${campaignManagerTheme.color.groundZeroSurface};
  border-left: 1px solid #e3e3e3;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
